import {
  createJSONStorage,
  type PersistStorage,
  type StateStorage,
} from "zustand/middleware"

import {
  createClientSettingStore,
  type ClientSetting,
} from "@be-miniapp/shared/stores"

const storage = createJSONStorage(
  () => localStorage as unknown as StateStorage
) as PersistStorage<ClientSetting>

const useClientSetting = createClientSettingStore({ storage })

export { useClientSetting }
